import axios from "axios";
import { useSelector } from "react-redux";

axios.defaults.withCredentials = true;

// Create axios instance
const apiClient = axios.create({
  baseURL: 'https://api.t-trades.net',
  headers: {
    "Content-type": "application/json",
    withCredentials: true,
  }
});

// Request interceptor to add auth token dynamically for each request
apiClient.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem('auth-token');
    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data on 401
      localStorage.removeItem('auth-token');
      localStorage.removeItem('user');
      localStorage.setItem('authstatus', false);
      
      // Dispatch logout event
      const event = new Event('userIsLoggedOut');
      window.dispatchEvent(event);
      
      // Redirect to login if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;